import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';
import {
  Answers,
  LoadingAnswer,
  Question,
  StyledLoadingMask,
  StyledQuestions,
} from './QuestionsStyles';

const QuestionsLoading = ({ questions, answers }) => {
  const randomWidths = useMemo(
    () => times(questions * answers).map(() => `${((Math.random() / 2 + 0.5) * 200).toFixed(0)}px`),
    [questions, answers],
  );

  return (
    <StyledQuestions>
      {times(questions).map(key => (
        <React.Fragment key={key}>
          <Question>
            <StyledLoadingMask width="600px" height="14px" />
          </Question>
          <Answers>
            {times(answers).map(answerKey => (
              <LoadingAnswer key={answerKey}>
                <StyledLoadingMask width="23px" height="23px" />
                <StyledLoadingMask width={randomWidths[answerKey + key * answers]} height="14px" />
              </LoadingAnswer>
            ))}
          </Answers>
        </React.Fragment>
      ))}
    </StyledQuestions>
  );
};

QuestionsLoading.defaultProps = {
  questions: 5,
  answers: 4,
};

QuestionsLoading.propTypes = {
  questions: PropTypes.number,
  answers: PropTypes.number,
};

export default QuestionsLoading;
